import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, notesTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteNoteAction } from "redux/reducers/notesReducer"
import { AppColors } from "resources/AppColors"

function DeleteNoteDialog() {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteNote() {
    dispatch(deleteNoteAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate('/notes')
  }

  return (
    <CustomDialog
      title={notesTexts.DELETED_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {notesTexts.DELETED_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteNote}
          data-cy="submit-delete-note-button"
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteNoteDialog